module.exports = __webpack_public_path__ + "static/img/kols12.9ecd216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols12.png
// module id = L53K
// module chunks = 0